// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { ErrorInformationStorage } from "../../Commons/ErrorInformationStorage.ts";
import { Color } from "../../Commons/Graphics.ts";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.ts";
import { ThemeManager } from "../misc/ThemeManager.js";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.ts";

export let FullLogsItem = function (info)
{
    BaseItem.call(this, null);

    FullLogsItem.StaticID++;
    this.ItemId = FullLogsItem.StaticID;
    this.info = info;
    if (info && info.IsOutgoingMSG)
    {
        let colorMap = FullLogsItem.GetOutgoingColorMaps()
        this.CellBackColorMap = colorMap.BackColor;
        this.CellForeColorMap = colorMap.ForeColor;
    }
};
FullLogsItem.prototype = Object.create(BaseItem.prototype);


FullLogsItem.prototype.ColumnCount = function ()
{
    return FullLogsItem.columnsParams.length;
}

FullLogsItem.prototype.GetColumnParams = function (column)
{
    var result = FullLogsItem.columnsParams[column];
    return result;
}

FullLogsItem.prototype.getColumnData = function (column)
{
    var o = "";
    try
    {
        o = this.getColumnValue(column);
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
    }
    let FormattedValue = o !== null && o !== undefined ? o.toString() : "";
    return { Value: o, FormattedValue: FormattedValue };
}

FullLogsItem.prototype.getColumnValue = function (column)
{
    try
    {
        if (this.info == null)
            return "";

        switch (column)
        {
            case 0:
                //if (BaseApplication.App.Settings != null && BaseApplication.App.MultiDataCache.DCache != null)
                //    return BaseApplication.App.Settings.ConvertUTCTimeToSelectedTimeZone(info.dateTime, BaseApplication.App.MultiDataCache.DCache).toString("HH:mm:ss.fff");
                //else
                return DateTimeUtils.formatDate(this.info.dateTime, "HH:mm:ss:SSS");
            //return info.dateTime.toString("HH:mm:ss.fff");

            case 1:
                return this.info.MessageName + " (" + this.info.MessageCode + ")";

            case 2:
                return this.info.Text;

            case 3:
                return this.info.NodeAddress;

            case 4:
                return this.info.Session;

            case 5:
                return this.info.Side;

            case 6:
                return this.info.TextNew;

            case 7:
                return this.info.StringMode;
            default:
                return "";
        }
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
        return "";
    }
}

FullLogsItem.StaticID = 0;

FullLogsItem.columnsParams = [

    new ColumnParams("FullLogs.DateTime", 15, 0, false, true, false),
    new ColumnParams("FullLogs.Message name", 60, 0, false, true, true),
    new ColumnParams("FullLogs.Fields", 80, 0, false, true, true),
    new ColumnParams("FullLogs.Cluster", 20, 0, false, false, true),
    new ColumnParams("FullLogs.Session", 20, 0, false, false, true),
    new ColumnParams("Direction", 20, 0, false, false, true),
    new ColumnParams("FullLogs.FieldsNew", 80, 0, false, false, true),
    new ColumnParams("FullLogs.Mode", 80, 0, false, false, true)
];

FullLogsItem.GetOutgoingColorMaps = function ()
{
    let result = { ForeColor: [], BackColor: [] }
    for (let i = 0; i < FullLogsItem.columnsParams.length; i++)
    {
        result.BackColor.push(ThemeManager.CurrentTheme.FullLogPanel_OutgoingMessageBackColor)
        result.ForeColor.push(Color.Black)
    }
    return result
}


//public static Action<ServerMessaeContainer> ServerMessage;
export let ServerMessaeContainer = function ()
{
    /// <summary>
    ////дэйт-тайм мессаджа
    /// </summary>
    this.dateTime = null;

    /// <summary>
    ////айди (код) мессаджа
    /// </summary>
    this.MessageCode = null;
    this.MessageName = "";
    /// <summary>
    /// Содержимое мессаджа
    /// </summary>
    this.Text = "";

    /// <summary>
    /// Содержимое мессаджа в читаемом виде
    /// </summary>
    this.TextNew = null;

    /// <summary>
    /// Содержимое мессаджа в читаемом виде
    /// </summary>
    this.DataForTreeView = null;

    /// <summary>
    /// Адрес ноды подключения (для кластера)
    /// </summary>
    this.NodeAddress = "";

    this.Side = ServerMessaeContainer.ServerMessaeSide.Input;

    this.Length = null;

    this.Mode = null;
    this.StringMode = "";

    /// <summary>
    /// Сессия (айди подключения)
    /// Может быть пустой (пока сервер не подключил меня)
    /// </summary>
    this.Session = "";
}

ServerMessaeContainer.ServerMessaeSide =
{
    Input: 0,
    Output: 1
}